<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-container modal-container--alert">
        <div class="modal-body text-center">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-style-c btn-lg"
            data-test="alert-button-cancel"
            @click="$emit('close')"
          >
            No, cancel.
          </button>
          <button
            class="btn btn-danger btn-lg"
            data-test="alert-button-confirm"
            @click="$emit('confirm')"
          >
            Yes, I'm sure.
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  emits: ['close', 'confirm'],
  name: 'alert',
};
</script>
